<div class="order-identificator-common-view">
  <div class="uuid">
    <span>{{uuid}}</span>
  </div>
</div>